import { post, postWithJson } from "@/utils/request";
import { FormSubmitRequest, FormDetailResponse, WxInfoResponse } from '@/types/form'
import { ApiResponse } from '@/types/common';

const prefix = '/api'
/**
 * {@link} https://nei.hz.netease.com/interface/detail/?pid=60533&id=407953
 */
export const getFormDetail = (params: { formId: number, }): Promise<[unknown, ApiResponse<FormDetailResponse>]> => {
  return post(prefix + "/formOpenApi/detailForSubmit", params);
};

/**
 * {@link} https://nei.hz.netease.com/interface/detail/res/?pid=60533&id=408011
 */
export const submitForm = (params: FormSubmitRequest): Promise<[unknown, ApiResponse<string>]> => {
  return postWithJson(prefix + "/formOpenApi/submit", params);
};

/**
 * 根据微信code获取用户信息
 * {@link} https://nei.hz.netease.com/interface/detail/?pid=60533&id=408185
 */
export const getWxInfo = (params: { code: string }): Promise<[unknown, ApiResponse<WxInfoResponse>]> => {
  return post(prefix + "/formOpenApi/wechatUserByCode", params);
};

/**
 * 获取表单验证码
 * {@link} https://nei.hz.netease.com/interface/detail/?pid=60533&id=412673
 */
export const sendCode = (params: { formId: number, mobile: string, }): Promise<[unknown, ApiResponse<WxInfoResponse>]> => {
  return post(prefix + "/formOpenApi/sendCode", params);
};
